import { isLikelyMobile } from './isLikelyMobile';

/** Boîtiers / navigateurs TV (Android TV, Fire TV, Chromecast, téléviseurs connectés). */
const TV_UA =
    /\b(TV|AFT[A-Z0-9]*|BRAVIA|SMART-TV|SmartTV|GoogleTV|CrKey|Chromecast|Tizen|Web0S|webOS|HbbTV|NetCast|MIBOX[A-Z0-9]*|SHIELD|DTV|Box)\b/i;
/** Téléphones seulement : iPhone, ou Android avec « Mobile » (un iPad en « site mobile » a aussi « Mobile »). */
const PHONE_UA = /iPhone|Android.*Mobile/;

/**
 * Téléphone probable, plus strict que `isLikelyMobile` (qui ne sert qu'à différer
 * le tutoriel) : il décide si la page TV est remplacée par l'accueil téléphone,
 * donc un faux positif sur une vraie TV de bar coûterait cher. En plus du
 * tactile + petit écran, exige un user-agent de téléphone (PHONE_UA, sans iPad)
 * et écarte les user-agents de TV — un boîtier Android 1080p à ×2 se déclare souvent tactile
 * avec un écran de 960×540.
 */
export function isLikelyPhone() {
    try {
        const ua = navigator.userAgent || '';
        return isLikelyMobile() && PHONE_UA.test(ua) && !/iPad/.test(ua) && !TV_UA.test(ua);
    } catch {
        return false;
    }
}
